import {
  StyledPageContainer,
  StyledPaywallContainer,
} from 'fitify-ui-onboarding/src/components/Paywall/Paywall.Styled'
import { usePromoContext } from 'fitify-ui-onboarding/src/contexts/PromoContext'
import type {
  SubscriptionPageConfig,
  SubscriptionProvider,
} from 'fitify-ui-onboarding/src/types/subscription'
import type { ReactNode } from 'react'

import { DEFAULT_PROMO_CODE } from 'data/promo'
import { useFunnel } from 'hooks/useFunnel'
import { FeaturedIn } from 'sections/subscription/FeaturedIn'
import { GoalComparison } from 'sections/subscription/GoalComparison/GoalComparison'
import { MoneyBackGuarantee } from 'sections/subscription/MoneyBackGuarantee'
import { PlanHighlights } from 'sections/subscription/PlanHighlights'
import { PromoImage } from 'sections/subscription/PromoImage/PromoImage'
import { Reviews } from 'sections/subscription/Reviews'
import { UserResults } from 'sections/subscription/UserResults'

import { PlanLoader } from '../Plan/PlanLoader'

type Props = {
  pageConfig?: SubscriptionPageConfig
  subscriptionProvider?: SubscriptionProvider
  topPlanComponent?: ReactNode
  bottomPlanComponent?: ReactNode
}

export const SubscriptionContent = ({
  bottomPlanComponent,
  pageConfig,
  subscriptionProvider,
  topPlanComponent,
}: Props) => {
  const funnel = useFunnel()
  const { promoCode } = usePromoContext()

  const shouldShowGoalComparison = Boolean(
    !promoCode || promoCode === DEFAULT_PROMO_CODE
  )

  return (
    <StyledPageContainer>
      {pageConfig && Boolean(promoCode) && (
        <PromoImage pageConfig={pageConfig} />
      )}
      <StyledPaywallContainer>
        {shouldShowGoalComparison && funnel && (
          <GoalComparison funnel={funnel} />
        )}
        {subscriptionProvider?.arePlansLoaded && topPlanComponent ? (
          topPlanComponent
        ) : (
          <PlanLoader planTitle={pageConfig?.planTitle} />
        )}
        <PlanHighlights />
        <FeaturedIn />
        <UserResults />
        <Reviews />
        {subscriptionProvider?.arePlansLoaded && bottomPlanComponent ? (
          bottomPlanComponent
        ) : (
          <PlanLoader planTitle={pageConfig?.planTitle} />
        )}
        <MoneyBackGuarantee />
      </StyledPaywallContainer>
    </StyledPageContainer>
  )
}
